
import { mapGetters } from 'vuex';

const SUPPORTED_LANGUAGES = ['ru', 'en', 'be', 'kk', 'tt', 'uk', 'uz', 'tr'];
const DEFAULT_LANGUAGE = 'en';

export default {
  name: 'YandexCaptcha',
  data: () => ({
    widgetId: null,
  }),
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      getLang: 'localization/getLang',
      getTranslations: 'localization/getTranslations',
      getCaptchaVisibility: 'system/getCaptchaVisibility',
      getCaptchaCallback: 'system/getCaptchaCallback'
    }),
  },
  mounted() {
    this.addCaptchaScript();
  },
  methods: {
    addCaptchaScript() {
      // SDK already present (e.g. re-mount) — render right away.
      if (window.smartCaptcha) {
        this.addCaptcha();
        return;
      }
      const captchaScript = document.createElement('script');
      captchaScript.setAttribute('src', 'https://smartcaptcha.yandexcloud.net/captcha.js');
      // Render only after the SDK has actually loaded. A fixed setTimeout raced on
      // slow networks: captcha.js was not ready yet -> window.smartCaptcha undefined
      // -> "Cannot read properties of undefined (reading 'render')" -> captcha never
      // showed -> SMS auth impossible -> retry storm (429).
      captchaScript.onload = () => this.addCaptcha();
      document.head.appendChild(captchaScript);
    },
    addCaptcha() {
      if (!window.smartCaptcha) {
        return;
      }
      this.widgetId = window.smartCaptcha.render(this.$refs.yaCaptcha, {
        sitekey: process.env.SMARTCAPTCHA_KEY,
        hl: SUPPORTED_LANGUAGES.includes(this.getLang) ? this.getLang : DEFAULT_LANGUAGE,
        callback: this.callbackCaptcha,
      });
    },
    callbackCaptcha(token) {
      this.$store.commit('system/SET_CAPTCHA_HEADER', token);

      this.getCaptchaCallback();

      this.$store.commit('system/SET_CAPTCHA_VISIBILITY', false);
      this.$store.commit('system/SET_CAPTCHA_CALLBACK', () => {});
      setTimeout(() => {
        this.$store.commit('system/SET_CAPTCHA_HEADER', null);
      }, 200);
    }
  },
};
